"use client";

import React, { useEffect, useState, useRef } from "react";
import { ArrowRight } from "lucide-react";
const useRevealOnScroll = (options = {
  threshold: 0.1,
  once: true
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        if (options.once) observer.unobserve(entry.target);
      }
    }, options);
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [options]);
  return {
    ref,
    isVisible
  };
};
const Button = ({
  children,
  className,
  onClick,
  ...props
}) => <button className={`inline-flex items-center justify-center transition-all ${className}`} onClick={onClick} {...props}>
    {children}
  </button>;
const CustomLink = ({
  href,
  children,
  className
}) => <a href={href} className={className}>
    {children}
  </a>;
export default function App() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const poster = "https://namo-catering.de/wp-content/uploads/2026/02/Gemini_Generated_Image_mokc9hmokc9hmokc-scaled.jpg";
  return <section id="hero" className="relative w-full min-h-screen flex items-center overflow-hidden bg-[#1a1a1a]">
      <div className="absolute inset-0 z-0">

        {/*  Desktop-Video (Querformat) – versteckt auf Mobile */}
        <video className="hidden md:block absolute inset-0 z-10 h-full w-full object-cover object-[45%_center]" autoPlay muted loop playsInline preload="auto" poster={poster}>
          <source src="https://namo-catering.de/wp-content/uploads/2026/03/Querformat_264.mp4" type="video/mp4" />
        </video>

        {/*  Mobile-Video (Hochformat) – versteckt auf Desktop */}
        <video className="block md:hidden absolute inset-0 z-10 h-full w-full object-cover object-center" autoPlay muted loop playsInline preload="auto" poster={poster}>
          <source src="https://namo-catering.de/wp-content/uploads/2026/03/Hochformat_komrpimieert.mp4" type="video/mp4" />
        </video>

        {/* Overlay: links dunkel → Text lesbar, rechts transparent → Video sichtbar */}
        <div className="absolute inset-0 z-20 bg-gradient-to-r from-black/80 via-black/55 to-black/15" />
        <div className="absolute inset-0 z-20 bg-gradient-to-t from-black/25 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="container relative z-30 px-4 mx-auto w-full">
        <div ref={ref} className={`w-full flex justify-center md:justify-start transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="flex flex-col gap-6 md:gap-8 max-w-xl md:max-w-2xl text-center md:text-left items-center md:items-start">
            <h1 className="text-white text-4xl font-black leading-tight md:text-6xl lg:text-7xl drop-shadow-2xl">
              Neapolitanisches Pizza Catering
              <br />
              in Köln &amp; Umgebung
            </h1>

            <p className="text-white/90 text-lg md:text-2xl leading-relaxed drop-shadow-xl">
              Live vor Ort gebacken mit mobilem Pizzaofen, hochwertigen Zutaten
              und echtem Show-Backen.
              <br className="hidden md:block" />
              Perfekt für private Feiern, Firmen-Events und Hochzeiten.
            </p>

            <Button className="group relative transform bg-[#FDC12F] text-[#436C1A] shadow-xl transition-all duration-300 hover:scale-110 hover:bg-white hover:shadow-2xl active:scale-95 px-12 py-6 text-xl md:text-2xl font-black uppercase rounded-2xl flex items-center gap-3">
              <CustomLink href="https://www.namo-catering.de/Kontaktaufnahme" className="flex items-center gap-3">
                <span>Jetzt anfragen</span>
                <ArrowRight className="group-hover:translate-x-2 transition-transform" />
              </CustomLink>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}